import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { JwtService } from "../jwt.service";
import { RoleEnum } from "../../models/user/role.interface";

@Injectable()
export class FranchiseGuardService implements CanActivate {

  constructor(
    private router: Router,
    private jwtService: JwtService
  ) {}

  canActivate() {
    if (localStorage.getItem("token") != null) {
      const role = this.jwtService.getRoleName(localStorage.getItem("token"));
      if (role == RoleEnum.ROLE_FRANCHISE) {
        return true;
      }
    }

    this.router.navigate(["dashboard"]);
    return false;
  }
}
